import React from 'react'
import { Text, Image, View, StyleSheet } from '@react-pdf/renderer'

const styles = StyleSheet.create({
  tableHeaderTitle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  tableHeaderTitleText1: {
    fontFamily: 'Inter',
    fontSize: 15,
    fontWeight: 500,
    marginRight: 5,
    color: '#fff',
  },
  tableHeaderTitleText2: {
    fontFamily: 'Inter',
    fontSize: 12,
  },
  overviewText: {
    fontFamily: 'Inter',
    fontSize: 10,
    fontWeight: 500,
    paddingTop: 3,
    paddingBottom: 3,
    marginTop: 4,
    marginBottom: 4,
  },
  icon: {
    display: 'block',
    marginVertical: 15,
    marginHorizontal: 'auto',
    width: '6%',
  },
  tableHeaderCol: {
    fontFamily: 'Inter',
    fontSize: 8,
    fontWeight: 700,
    textAlign: 'left',
    paddingLeft: 5,
    paddingBottom: 10,
  },
  tableBodyCol: {
    fontFamily: 'Inter',
    fontSize: 9,
    fontWeight: 400,
    textAlign: 'left',
    paddingLeft: 5,
    paddingTop: 8,
    paddingBottom: 8,
  },
  tableBodyColBold: {
    fontFamily: 'Inter',
    fontSize: 9,
    fontWeight: 600,
    textAlign: 'left',
    paddingLeft: 5,
    paddingTop: 8,
    paddingBottom: 8,
  }
});

const OverviewTable = ({ coverData, uiData }) => {

  const roundToTwoDecimals = (num) => {
    const rounded = Math.round(num * 100) / 100;
    return rounded % 1 === 0 ? `${rounded}.00` : rounded.toFixed(2);
  };


  const transformedTeamsStats = coverData.profile.map((profile, index) => ({
    profile,
    minimum: {
      points: coverData.minimum.points[index],
      category: coverData.minimum.category[index]
    },
    maximum: {
      points: coverData.maximum.points[index],
      category: coverData.maximum.category[index]
    },
    diffMaxMin: coverData.diffMaxMin[index],
    avgPoint: coverData.avgPoint[index]
  }));

  //console.log(JSON.stringify(transformedTeamsStats, null, 2));

  return (
    <>
      <View>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%',
            paddingLeft: '5%',
            paddingRight: '5%',
            backgroundColor: roundToTwoDecimals(coverData.overview.avgPoint) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.avgPoint) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.avgPoint) <= 4 ? "#7bb662" : "#639754")),
          }}
        >
          <View style={styles.tableHeaderTitle}>
            <Text style={styles.tableHeaderTitleText1}>{uiData.features}</Text>
          </View>

          <View
            style={{
              color: '#ffffff',
              fontFamily: 'Inter',
              fontSize: 18,
              fontWeight: 700,
              padding: 5,
            }}
          >
            <Text>{roundToTwoDecimals(coverData.overview.avgPoint)}</Text>
          </View>

        </View>
      </View>

      <View style={{ paddingRight: '5%', paddingLeft: '5%' }}>
        <View
          style={{
            backgroundColor: '#ffffff',
            border: '1 solid rgb(226 232 240)',
            borderRadius: 5,
            padding: 20,
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            marginTop: 25,
          }}
        >
          <View style={{ width: '40%' }}>
            <Text style={styles.overviewText}>{uiData.date}</Text>
            <Text style={styles.overviewText}>{uiData.minimum}</Text>
            <Text style={styles.overviewText}>{uiData.maximum}</Text>
            <Text style={styles.overviewText}>{uiData.difference}</Text>
            <Text style={styles.overviewText}>{uiData.average}</Text>
          </View>

          <View style={{ width: '60%' }}>
            <View>
              <View>
                <View>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 600,
                      paddingTop: 7,
                      paddingBottom: 8,
                    }}
                  >
                    {coverData.timestamp}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                    marginTop: 3,
                    marginBottom: 4,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      borderRadius: 3,
                      marginRight: 8,
                      color: '#fff',
                      width: 32,
                      backgroundColor: roundToTwoDecimals(coverData.overview.minimum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.minimum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.minimum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.overview.minimum.points)}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      color: roundToTwoDecimals(coverData.overview.minimum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.minimum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.minimum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {coverData.overview.minimum.category}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                    marginTop: 3,
                    marginBottom: 4,
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      borderRadius: 3,
                      marginRight: 8,
                      color: '#fff',
                      width: 32,
                      marginTop: 1,
                      backgroundColor: roundToTwoDecimals(coverData.overview.maximum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.maximum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.maximum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.overview.maximum.points)}
                  </Text>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      color: roundToTwoDecimals(coverData.overview.maximum.points) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.maximum.points) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.maximum.points) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {coverData.overview.maximum.category}
                  </Text>
                </View>
                <View>
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      display: 'inline',
                      textAlign: 'center',
                      width: 32,
                      paddingLeft: 5,
                      paddingRight: 5,
                      paddingTop: 3,
                      paddingBottom: 3,
                      marginTop: 4,
                      marginBottom: 4,
                    }}
                  >
                    {roundToTwoDecimals(coverData.overview.diffMaxMin)}
                  </Text>
                </View>
                <View
                  style={{
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  <Text
                    style={{
                      fontFamily: 'Inter',
                      fontSize: 10,
                      fontWeight: 700,
                      paddingTop: 3,
                      paddingBottom: 3,
                      paddingLeft: 5,
                      paddingRight: 5,
                      borderRadius: 3,
                      width: 32,
                      color: '#fff',
                      marginTop: 4,
                      backgroundColor: roundToTwoDecimals(coverData.overview.avgPoint) <= 2 ? "#dc2626" : (roundToTwoDecimals(coverData.overview.avgPoint) <= 3 ? "#eac714" : (roundToTwoDecimals(coverData.overview.avgPoint) <= 4 ? "#7bb662" : "#639754")),
                    }}
                  >
                    {roundToTwoDecimals(coverData.overview.avgPoint)}
                  </Text>
                </View>
              </View>
            </View>
          </View>
        </View>
      </View>

      <Image style={styles.icon} src={`${process.env.PUBLIC_URL}/teams-icon.png`} />

      <View style={{ paddingRight: '5%', paddingLeft: '5%' }}>
        <View
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            width: '100%',
            paddingLeft: 18,
            paddingRight: 18,
          }}
        >
          <View style={{
            width: '20%',
          }}>
            <Text
              style={styles.tableHeaderCol}
            >
              {uiData.department}
            </Text>
          </View>
          <View style={{
            width: '28%',
          }}>
            <Text
              style={styles.tableHeaderCol}
            >
              {uiData.minimum}
            </Text>
          </View>
          <View style={{
            width: '28%',
          }}>
            <Text
              style={styles.tableHeaderCol}
            >
              {uiData.maximum}
            </Text>
          </View>
          <View style={{
            width: '12%',
          }}>
            <Text
              style={{ ...styles.tableHeaderCol, textAlign: 'right' }}
            >
              {uiData.difference_short}
            </Text>
          </View>
          <View style={{
            width: '12%',
          }}>
            <Text
              style={{ ...styles.tableHeaderCol, textAlign: 'right' }}
            >
              {uiData.average}
            </Text>
          </View>
        </View>
      </View>

      <View style={{ paddingRight: '5%', paddingLeft: '5%' }}>
        <View
          style={{
            width: '100%',
            backgroundColor: '#ffffff',
            border: '1 solid rgb(226 232 240)',
            borderRadius: 5,
            paddingLeft: 17,
            paddingRight: 17,
            paddingTop: 10,
            paddingBottom: 10,
          }}
        >
          {transformedTeamsStats.map((entry, index) => {
            return (
              <View key={entry.profile}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'start',
                  width: '100%',
                  borderBottom: index !== transformedTeamsStats.length - 1 ? '0.5 solid rgb(226 232 240)' : 'none',
                }}
              >
                <View style={{
                  width: '20%',
                }}>
                  <Text
                    style={{ ...styles.tableBodyCol, paddingRight: 20 }}
                  >
                    {entry.profile}
                  </Text>
                </View>
                <View style={{
                  width: '28%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'start',
                }}>
                  <Text
                    style={styles.tableBodyColBold}
                  >
                    {roundToTwoDecimals(entry.minimum.points)}
                  </Text>
                  <Text
                    style={{ ...styles.tableBodyCol, paddingRight: 20 }}
                  >
                    {entry.minimum.category}
                  </Text>
                </View>
                <View style={{
                  width: '28%',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'start',
                  alignItems: 'start',
                }}>
                  <Text
                    style={styles.tableBodyColBold}
                  >
                    {roundToTwoDecimals(entry.maximum.points)}
                  </Text>
                  <Text
                    style={styles.tableBodyCol}
                  >
                    {entry.maximum.category}
                  </Text>
                </View>
                <View style={{
                  width: '12%',
                }}>
                  <Text
                    style={{ ...styles.tableBodyColBold, textAlign: 'right' }}
                  >
                    {roundToTwoDecimals(entry.diffMaxMin)}
                  </Text>
                </View>
                <View style={{
                  width: '12%',
                }}>
                  <Text
                    style={{ ...styles.tableBodyColBold, textAlign: 'right' }}
                  >
                    {roundToTwoDecimals(entry.avgPoint)}
                  </Text>
                </View>
              </View>
            );
          })}
        </View>
      </View>

    </>
  )
}

export default OverviewTable